export function getRadiusFromBounds(bounds) {
    const { lat: north, lng: east } = bounds._northEast;
    const { lat: south, lng: west } = bounds._southWest;

    // Calculate center point
    const centerLat = (north + south) / 2;
    const centerLng = (east + west) / 2;

    // Distance from center to the northeast corner (approximate radius)
    return getDistance(centerLat, centerLng, north, east);
}

function getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of Earth in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
}

export const worldPopupHtml = ({ formattedNumber }) => `
    <div style="font-weight: 500;">
        You can sleep in ${formattedNumber} properties
    </div>
    <button style="border: none;margin-top: 10px;background: none;padding: 0;color: #0000de;text-decoration: underline;" onClick="window.vueApp.setZoomLevel(2, 37, 3)">View Continents</button>
`;

export const continentPopupHtml = ({ formattedNumber, continent }) => `
    <div style="font-weight: 500;width: 200px;padding: 10px 0;font-size:13px">
        You can sleep in ${formattedNumber} properties in ${continent.name}
    </div>
    <button style="
        border: none;
        margin-top: 10px;
        background: none;
        padding: 0;
        color: #0000de;
        text-decoration: underline;"
        onclick="window.vueApp.setZoomLevel(4, ${continent.latitude}, ${continent.longitude})">
        View ${continent.name}
    </button>
`;

export const countryPopupHtml = ({ formattedNumber, country }) => `
    <div style="font-weight: 500;width: 200px;padding: 10px 0;font-size:13px">
        You can sleep in ${formattedNumber} properties in ${country.name}
    </div>
    <button style="
        border: none;
        margin-top: 10px;
        background: none;
        padding: 0;
        color: #0000de;
        text-decoration: underline;"
        onclick="window.vueApp.setZoomLevel(7, ${country.latitude}, ${country.longitude})">
        View ${country.name}
    </button>
`;

export const propertyPopupHtml = ({ item, labels, listId = null }) => `
    <div class="image_section">
        <a target="_blank" href="/listing/${item.id}${listId ? `?list_id=${encodeURIComponent(listId)}` : ""}">
            <img
                src="${item.image}"
                style="width: 200px; margin-bottom: 5px;"
                alt="${item.name}"
            />
        </a>
    </div>

    <div class="image_title">
        <h5>
            <a target="_blank" href="/listing/${item.id}${listId ? `?list_id=${encodeURIComponent(listId)}` : ""}">
                ${item.name}
            </a>
        </h5>

        <div style="padding-bottom: 5px; margin-top: 10px;">
            ${item.address || ''}
        </div>

        <div style="padding-bottom: 5px;">
            Property ID: ${item.id}
        </div>

        <div style="padding-bottom: 10px;">
            Property Type: ${labels}
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center;">

            <a target="_blank" href="/listing/${item.id}${listId ? `?list_id=${encodeURIComponent(listId)}` : ""}">
                <button class="map-book-button">
                    Book Now
                </button>
            </a>
        </div>
    </div>
`;